import React, { useEffect, useState, useCallback } from "react";

import { Link, useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setLoading, setModule } from "../../store/actions/commonAction";
import CommonDataService from "../../services/common";
import {
	AllowedUsergroup,
	GetIndexByValue,
	parseNumber,
} from "../../helpers/common";

import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Divider from "@mui/material/Divider";
import SaveIcon from "@mui/icons-material/Save";

import dayjs from "dayjs";

import MessageDialog from "../MessageDialog";
import http from "../../http";

export default function AddVideos({ placeholder }) {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	let { id } = useParams();

	const company = useSelector((state) => state.commonReducer.user.company);
	const userGroup = useSelector((state) => state.commonReducer.user.usergroup);
	const loading = useSelector((state) => state.commonReducer.loading);

	const [message, setMessage] = useState("");
	const [error, setError] = useState(false);

	const [offices, setOffices] = useState([]);
	const [idOffice, setIdOffice] = useState(company);
	const [idOfficeAC, setIdOfficeAC] = useState(null);
	const [title, setTitle] = useState("");
	const [youtubeId, setYoutubeId] = useState("");
	const [publishTime, setPublishTime] = useState(dayjs());
	const [active, setActive] = useState(true);
	const [uniqueName, setUniqueName] = useState("");

	const LoadSelect = useCallback(() => {
		dispatch(setLoading(true));
		dispatch(setModule("Videos"));

		if (typeof id !== "undefined") {
			CommonDataService.getVideoById(id).then((res) => {
				setIdOffice(res.data.Row.id_office);
				setTitle(res.data.Row.title);
				setPublishTime(dayjs(res.data.Row.publish_time));
				setActive(res.data.Row.active);
				setUniqueName(res.data.Row.unique_name);
				setYoutubeId(res.data.Row.youtube_id);
				dispatch(setLoading(false));
			});
		} else {
			dispatch(setLoading(false));
		}

		if (AllowedUsergroup(userGroup, "superuser-website")) {
			CommonDataService.getOffices().then((res) => {
				setOffices(res.data);
			});
		}
	}, [dispatch, id, userGroup]);

	useEffect(() => {
		setIdOfficeAC(GetIndexByValue(offices, idOffice));
	}, [offices, idOffice]);

	useEffect(() => {
		LoadSelect();
	}, [LoadSelect]);

	const handleSubmit = (event) => {
		event.preventDefault();

		if (typeof id === "undefined") {
			id = 0;
		}

		dispatch(setLoading(true));

		const data = {
			id: parseNumber(id),
			id_office: parseNumber(idOffice),
			title: title,
			youtube_id: youtubeId,
			publish_time: dayjs(publishTime).format("YYYY-MM-DD HH:mm:ss"),
			active: active,
			unique_name: uniqueName,
		};

		http
			.post("/videos/save", data)
			.then((res) => {
				dispatch(setLoading(false));
				navigate("/videos" + window.location.search);
			})
			.catch(function (error) {
				setMessage(error.response.data.message);
				setError(true);
				dispatch(setLoading(false));
			});
	};

	return (
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<MessageDialog show={error} message={message} dialogClose={setError} />

				<Paper
					sx={{
						p: 2,
						display: "flex",
						flexDirection: "column",
					}}
				>
					<Box component="form" onSubmit={(e) => handleSubmit(e)}>
						<Typography variant="h5">Videos Form</Typography>

						<Grid container spacing={3}>
							{id > 0 && (
								<Grid item xs={12} sm={12}>
									<iframe
										width="560"
										height="315"
										src={
											"https://www.youtube.com/embed/" +
											youtubeId +
											"?controls=0"
										}
										title="YouTube video player"
										frameborder="0"
										allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
										allowfullscreen
									></iframe>
								</Grid>
							)}

							{AllowedUsergroup(userGroup, "superuser-website") && (
								<Grid item xs={12} sm={12}>
									<Autocomplete
										id="id_office"
										name="id_office"
										options={offices}
										getOptionLabel={(option) => option.name}
										isOptionEqualToValue={(option, value) =>
											option.value === value.value
										}
										fullWidth={true}
										onChange={(e, val) => {
											if (val !== null) {
												setIdOffice(val.id);
											} else {
												setIdOffice("");
											}
										}}
										value={idOfficeAC}
										sx={{ minWidth: 100 }}
										renderInput={(params) => (
											<TextField
												variant="standard"
												{...params}
												label="Office"
											/>
										)}
									/>
								</Grid>
							)}

							<Grid item xs={12} sm={6}>
								<TextField
									required
									label="Title"
									id="title"
									name="title"
									value={title}
									fullWidth
									variant="standard"
									onChange={(e) => setTitle(e.target.value)}
								/>
							</Grid>

							{typeof id !== "undefined" && (
								<Grid item xs={12} sm={6}>
									<TextField
										required
										label="Unique Name"
										id="uniqueName"
										name="uniqueName"
										value={uniqueName}
										fullWidth
										variant="standard"
										onChange={(e) => setUniqueName(e.target.value)}
									/>
								</Grid>
							)}
							<Grid item xs={12} sm={6}>
								<TextField
									label="Youtube ID"
									id="youtubeId"
									name="youtubeId"
									value={youtubeId}
									fullWidth
									variant="standard"
									onChange={(e) => setYoutubeId(e.target.value)}
								/>
							</Grid>

							<Grid item xs={12} sm={6}>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DateTimePicker
										label="Publish Time"
										value={publishTime}
										onChange={(e) => setPublishTime(dayjs(e))}
										renderInput={(params) => <TextField {...params} />}
									/>
								</LocalizationProvider>
							</Grid>

							<Grid item xs={12} sm={6}>
								<FormControlLabel
									control={
										<Checkbox
											checked={active === "true" || active === true}
											onChange={(e) => setActive(e.target.checked)}
										/>
									}
									label="Active"
								/>
							</Grid>

							<Grid item xs={12} sm={12}>
								<Divider />
							</Grid>

							<Grid item xs={12} sm={12}>
								<Button
									variant="contained"
									component={Link}
									to={"/videos" + window.location.search}
									startIcon={<ArrowBackIcon />}
									sx={{ mr: 1 }}
								>
									Cancel
								</Button>
								<Button
									type="submit"
									variant="contained"
									disabled={loading}
									startIcon={<SaveIcon />}
								>
									{loading && (
										<span>
											<span className="spinner-border spinner-border-sm"></span>
											&nbsp;
										</span>
									)}
									<span> {loading ? "Please Wait" : "Save"}</span>
								</Button>
							</Grid>
						</Grid>
					</Box>
				</Paper>
			</Grid>
		</Grid>
	);
}
